import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ItemCategoryService from "../../services/ItemCategoryService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import { useParams } from "react-router-dom";
import MessageDialog from "../../components/MessageDialog";


export default function AddItemCategory() {
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editLoading, setEditLoading] = useState(false); // NEW
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (id) {
      setIsEdit(true);
      setEditId(id);
      setEditMode(true);
      fetchItemCategoryById(id);
    } else {
      setIsEdit(false);
    }
  }, [id]);

  const fetchItemCategoryById = async (catId) => {
    setEditLoading(true); // START LOADING
    try {
      const res = await ItemCategoryService.getById(catId);

      if (res?.data) {
        const record = res.data;

        setValue("itemCategoryName", record.itemCategoryName || "");
        setValue("itemCategoryCode", record.itemCategoryCode || "");
        setValue("status", record.status || "Active");
      } else {
        showMessage("Failed to load Item Category.", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("Error fetching Item Category.", "error");
    } finally {
      setEditLoading(false);
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let res;

      if (isEdit && editId) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await ItemCategoryService.update(editId, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await ItemCategoryService.create({ ...data, status: "Active" });
      }

      const result = res;

      if (result.status) {
        showMessage(
          isEdit ? "Item updated successfully!" : "Item added successfully!",
          "success"
        );
        setTimeout(() => navigate("/cpnl/itemcategory/view"), 1200);
        return;
      }

      showMessage(result.message || "Failed to save item.", "error");
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.response?.data?.msg ||
        error.message ||
        "Network error";

      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Item Category" : "Add Item Category"}
        secondTitle="Masters"
      ></Breadcrumb>

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType?.trim().toLowerCase() === "success"
                  ? "alert-success"
                  : "alert-danger"
                } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
              style={{ borderRadius: "5px" }}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
                style={{ fontSize: "0.8rem" }}
              />
            </div>
          )} */}

            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {/* 🔄 EDIT LOADING SPINNER */}
          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Item Category Name<span className="text-danger">*</span>
                  </label>
                  <input
                      type="text"
                      className={`form-control ${errors.itemCategoryName ? "is-invalid" : ""}`}
                      placeholder="Enter Item Category"
                      disabled={loading}
                    

                      {...register("itemCategoryName", {
                        required: "Item Category is required",
                        minLength: {
                          value: 2,
                          message: "Minimum 2 characters required",
                        },
                      })}
                  />
                  {errors.itemCategoryName && (
                    <small className="text-danger">
                      {errors.itemCategoryName.message}
                    </small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Item Category Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Category Code"
                    // {...register("itemCategoryCode", {
                    //   required: "Category Code is required",
                    //   // maxLength: { value: 20, message: "Max 20 characters" },
                    // })}

                      {...register("itemCategoryCode", {
                        required: "Category Code is required",
                      })}
                  />
                  {errors.itemCategoryCode && (
                    <small className="text-danger">
                      {errors.itemCategoryCode.message}
                    </small>
                  )}
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={loading}
              >
                <i className="ti ti-circle-check me-1"></i>
                {loading
                  ? isEdit
                    ? "Updating..."
                    : "Saving..."
                  : isEdit
                    ? "Update"
                    : "Save"}
              </button>

              <button
                type="button"
                className="btn btn-secondary mt-3 ms-2"
                onClick={() => {
                  navigate("/cpnl/itemcategory/view");
                }}
                disabled={loading}
              >
                <i className="ti ti-cancel me-1"></i>
                Cancel
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
